import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IconChevronLeft } from '@tabler/icons-react';
import BrandMark from './BrandMark';
import Button from '../common/Button';
import { useClinic } from '../../context/ClinicContext';
import { useAuth } from '../../context/AuthContext';
import { PATHS } from '../../routes/paths';

/** Pre-login header. `back` shows a back arrow + clinic name instead of the logo. */
export default function PublicHeader({ back = false, showDoctorsLink = true }) {
  const navigate = useNavigate();
  const { clinic } = useClinic();
  const { isAuthenticated } = useAuth();

  return (
    <header className={`public-header ${back ? 'public-header--back' : ''}`}>
      {back ? (
        <>
          <button type="button" className="icon-btn" onClick={() => navigate(-1)} aria-label="Back">
            <IconChevronLeft size={24} />
          </button>
          <span className="brand__name">{clinic?.name}</span>
        </>
      ) : (
        <Link to={PATHS.landing} aria-label="Home"><BrandMark withName /></Link>
      )}
      <nav className="public-header__nav">
        {showDoctorsLink && !back && <Link className="public-header__link" to={PATHS.doctors}>Doctors</Link>}
        {isAuthenticated ? (
          <Button variant="outline" size="xs" to={PATHS.home}>My account</Button>
        ) : (
          <Button variant="outline" size="xs" to={PATHS.login}>Log in</Button>
        )}
      </nav>
    </header>
  );
}
